import { render, staticRenderFns } from "./ProjectStatus.vue?vue&type=template&id=117cf243&"
import script from "./ProjectStatus.vue?vue&type=script&lang=ts&"
export * from "./ProjectStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports